import { Box } from '@mui/material';
import wordmark from './assets/wordmark.svg';
import wordmarkLight from './assets/wordmark-light.svg';

/** Fixed, upright Noto Sans SC Bold outlines; no runtime font download or substitution. */
export function Wordmark({
  height = 22,
  variant = 'dark',
}: {
  height?: number;
  variant?: 'dark' | 'light';
}) {
  return (
    <Box
      component="img"
      src={variant === 'light' ? wordmarkLight : wordmark}
      alt="联仓通"
      sx={{
        display: 'block',
        height,
        width: height * (3097 / 955),
        flexShrink: 0,
      }}
    />
  );
}
